export const DocViewType = Object.freeze({
  TECHNICAL: 'TECHNICAL', // 기술문서,
  DOWNLOAD: 'DOWNLOAD', // 자료관리.
  COMMUNITY: 'COMMUNITY', // 커뮤니티 글쓰기.
  ALLDOC: 'ALLDOC', // 전체문서.
});
